// src/Pages/Usuario/Agenda/components/ModalPago.jsx

import React, { useMemo, useState } from "react";
import { runOCR, scoreTransferText } from "../../../../utils/ocrComprobante";
import PagarLinkifyButton from "../../../Paciente/PagarLinkifyButton";

export default function ModalPago({
  pasoPago,
  setPasoPago,
  setModalAbierto,

  setMontoAPagarActual,

  // Datos usuario
  usuario,
  form,

  // Datos del servicio
  parsed,
  totalSesionesEstimadas,
  esPrimeraSesionReal,
  modalidadKine,

  // Precios
  precioFinal,
  mitadFinal,
  montoAPagarActual,

  // Plan
  planEntrada,
  esUltima,

  opcionPago,
  setOpcionPago,

  // Funciones pago
  abrirPago,
  registrarPagoYReserva,
  pagarPorTransferencia,
  copiarDatosTransferencia,

  formTransferencia,
  setFormTransferencia,
  enviando,

  // Slot
  primarySlot,

  configPago,
}) {

  // ===============================
  // MODALIDAD FINAL (plan o reserva suelta)
  // ===============================
  const modalidadFinal = planEntrada
  ? planEntrada.modalidad // viene del plan
  : modalidadKine;         // depende del selector

  const datosTransferencia = configPago?.transferencia || {};
  const transferenciaTextoCopiar = [
    datosTransferencia.nombre && `Nombre: ${datosTransferencia.nombre}`,
    datosTransferencia.rut && `RUT: ${datosTransferencia.rut}`,
    datosTransferencia.banco && `Banco/App: ${datosTransferencia.banco}`,
    (datosTransferencia.tipo_cuenta || datosTransferencia.cuenta) &&
      `Cuenta: ${datosTransferencia.tipo_cuenta ? datosTransferencia.tipo_cuenta + " — " : ""}${datosTransferencia.cuenta || ""}`,
    datosTransferencia.email && `Email: ${datosTransferencia.email}`,
  ].filter(Boolean).join("\n");

  const copiarDatosTransferenciaLocal = async () => {
  try {
    await navigator.clipboard.writeText(transferenciaTextoCopiar || "");
  } catch (e) {
    // fallback antiguo
    const ta = document.createElement("textarea");
    ta.value = transferenciaTextoCopiar || "";
    document.body.appendChild(ta);
    ta.select();
    document.execCommand("copy");
    document.body.removeChild(ta);
  }
  alert("Datos copiados ✔");
};

  // ======================================
  // OCR comprobante (Tesseract) - Paso 3
  // ======================================
  const [ocrLoading, setOcrLoading] = useState(false);
  const [ocrError, setOcrError] = useState("");
  const [ocrRaw, setOcrRaw] = useState("");
  const [declaracionOk, setDeclaracionOk] = useState(false);

  const ocrInfo = useMemo(() => {
    if (!ocrRaw) return null;
    return scoreTransferText(ocrRaw);
  }, [ocrRaw]);

  const esComprobanteProbable = ocrInfo?.verdict === "likely";
  const esComprobanteDudoso = ocrInfo?.verdict === "maybe";
  const esComprobanteImprobable = ocrInfo?.verdict === "unlikely";

  const onPickComprobante = async (file) => {
    setOcrError("");
    setOcrRaw("");
    setDeclaracionOk(false);

    if (!file) {
      setFormTransferencia({ comprobanteFile: null });
      return;
    }

    // Validaciones rápidas
    const isImage = file.type?.startsWith("image/");
    if (!isImage) {
      setOcrError("Solo se permiten imágenes (JPG/PNG/WebP).");
      setFormTransferencia({ comprobanteFile: null });
      return;
    }

    const maxMB = 8;
    if (file.size > maxMB * 1024 * 1024) {
      setOcrError(`La imagen supera ${maxMB}MB. Usa una más liviana.`);
      setFormTransferencia({ comprobanteFile: null });
      return;
    }

    // Guardar archivo igual (para que puedan seguir)
    setFormTransferencia({ comprobanteFile: file });

    // OCR
    setOcrLoading(true);
    try {
      const raw = await runOCR(file);
      setOcrRaw(raw || "");

      if (!raw || raw.trim().length < 10) {
        setOcrError(
          "No detectamos un comprobante válido. Intenta con una captura más nítida o marca la declaración para continuar."
        );
      }
    } catch (e) {
      console.error(e);
      setOcrError(
        "No pudimos detectar un comprobante válido. Intenta otra imagen o marca la declaración para continuar."
      );
    } finally {
      setOcrLoading(false);
    }
  };

  // Si hay ocrError o salió "unlikely", exigir declaración
  const requiereDeclaracion = !!ocrError || esComprobanteImprobable;

  const bloquearEnvio =
    !formTransferencia?.comprobanteFile ||
    ocrLoading ||
    (requiereDeclaracion && !declaracionOk);


  const onEnviarComprobante = async () => {
    const requiereDeclaracion = !!ocrError || esComprobanteImprobable;

    if (requiereDeclaracion && !declaracionOk) {
      alert("Marca la declaración para continuar.");
      return;
    }

    await pagarPorTransferencia();
  };



  return (
    <div className="fixed inset-0 z-50">
      {/* Overlay */}
      <div
        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
        onClick={() => setModalAbierto(false)}
      />

      {/* Modal */}
      <div className="absolute inset-0 flex items-center justify-center p-4">
        <div className="w-full max-w-lg bg-white rounded-2xl shadow-2xl overflow-hidden ring-1 ring-black/10">

          {/* ================================
              PASO 1 - Selección de tipo de pago
             ================================ */}
          {pasoPago === 1 && (
            <div className="p-6">
              <h4 className="text-xl font-semibold text-[#0E1A36] mb-1">
                Selecciona el tipo de pago
              </h4>
              <p className="text-sm text-[#4B5563]">
                {parsed.categoria}: {parsed.variante}
              </p>

              <div className="grid grid-cols-1 gap-3 mt-4">

                {/* ======================
                    CASO PLAN ACTIVO
                ====================== */}
                {planEntrada && (
                  <>
                    {/* Plan pagado al 100% */}
                    {planEntrada.monto_restante === 0 && (
                      <button
                        onClick={async () => {
                          await registrarPagoYReserva({
                            monto_pagado: 0,
                            pago_metodo: "incluida",
                            modalidad: modalidadFinal, 
                          });
                          setModalAbierto(false);
                        }}
                        className="w-full py-3 rounded-xl font-semibold shadow-lg bg-emerald-500 text-white hover:bg-emerald-600 transition"
                      >
                        Reservar sesión incluida
                      </button>
                    )}

                    {/* Tiene saldo pendiente */}
                    {planEntrada.monto_restante > 0 && (
                      <>
                        {/* SALDO RESTANTE */}
                        <button
                          onClick={() => {
                            setOpcionPago("plan_saldo");
                            setMontoAPagarActual(planEntrada.monto_restante);
                            setPasoPago(2);
                          }}
                          className="w-full border border-gray-300 rounded-xl p-4 text-left hover:bg-blue-50/40 transition"
                        >
                          <div className="flex items-center justify-between">
                            <div>
                              <div className="font-semibold text-[#0E1A36]">
                                Pagar saldo restante
                              </div>
                              <div className="text-sm text-gray-600">
                                Deuda pendiente del plan
                              </div>
                            </div>
                            <div className="text-[#0E1A36] font-bold">
                              ${planEntrada.monto_restante.toLocaleString("es-CL")}
                            </div>
                          </div>
                        </button>

                        {/* Pagar sesión → solo si NO es última */}
                        {!esUltima && (
                          <button
                            onClick={() => {
                              setOpcionPago("plan_sesion");
                              setMontoAPagarActual(planEntrada.precio_por_sesion);
                              setPasoPago(2);
                            }}
                            className="w-full border border-gray-300 rounded-xl p-4 text-left hover:bg-blue-50/40 transition"
                          >
                            <div className="flex items-center justify-between">
                              <div>
                                <div className="font-semibold text-[#0E1A36]">
                                  Pagar sesión
                                </div>
                                <div className="text-sm text-gray-600">
                                  Valor por sesión del plan
                                </div>
                              </div>
                              <div className="text-[#0E1A36] font-bold">
                                ${planEntrada.precio_por_sesion.toLocaleString("es-CL")}
                              </div>
                            </div>
                          </button>
                        )}
                      </>
                    )}
                  </>
                )}

                {/* ======================
                    SERVICIO NORMAL
                ====================== */}
                {!planEntrada && (
                  <>
                    {/* Pagar 100% */}
                    <button
                      onClick={() => {
                        setOpcionPago("full");
                        setMontoAPagarActual(precioFinal);
                        setPasoPago(2);
                      }}
                      className="w-full border border-gray-300 rounded-xl p-4 text-left hover:bg-blue-50/40 transition"
                    >
                      <div className="flex items-center justify-between">
                        <div>
                          <div className="font-semibold text-[#0E1A36]">
                            Pagar 100%
                          </div>
                          <div className="text-sm text-gray-600">Monto total</div>
                        </div>
                        <div className="text-[#0E1A36] font-bold">
                          ${precioFinal.toLocaleString("es-CL")}
                        </div>
                      </div>
                    </button>

                    {/* Pagar reserva 50% o pago inicial plan */}
                    <button
                      onClick={() => {
                        setOpcionPago("half");
                        setMontoAPagarActual(mitadFinal);
                        setPasoPago(2);
                      }}
                      className="w-full border border-gray-300 rounded-xl p-4 text-left hover:bg-blue-50/40 transition"
                    >
                      <div className="flex items-center justify-between">
                        <div>
                          <div className="font-semibold text-[#0E1A36]">
                            {totalSesionesEstimadas > 1
                              ? "Pagar reserva"
                              : "Pagar 50%"}
                          </div>
                          <div className="text-sm text-gray-600">
                            {totalSesionesEstimadas > 1
                              ? "Pago inicial para activar el plan"
                              : "Monto a transferir ahora"}
                          </div>
                        </div>
                        <div className="text-[#0E1A36] font-bold">
                          ${mitadFinal.toLocaleString("es-CL")}
                        </div>
                      </div>
                    </button>
                  </>
                )}
              </div>

              <div className="mt-5 flex justify-end">
                <button
                  className="px-4 py-2 text-sm text-gray-600 hover:text-gray-800"
                  onClick={() => setModalAbierto(false)}
                >
                  Cerrar
                </button>
              </div>
            </div>
          )}

          {/* ================================
              PASO 2 - Método de pago
             ================================ */}
          {pasoPago === 2 && (
            <div className="p-6">
              <h4 className="text-xl font-semibold text-[#0E1A36] mb-1">
                Selecciona el método de pago
              </h4>
              <p className="text-sm text-[#4B5563]">
                {parsed.categoria}: {parsed.variante} ·{" "}
                <span className="font-semibold text-[#0E1A36]">
                  ${montoAPagarActual.toLocaleString("es-CL")}
                </span>
              </p>

              <div className="mt-4 space-y-3">
               {configPago?.mostrar_linkify && (
                <PagarLinkifyButton
                  pacienteId={usuario?.uid || null}
                  nombre={`${form.nombres} ${form.apellidos}`.trim()}
                  rut={form.rut}
                  email={usuario?.email || form.correo}
                  celular={form.celular}
                  direccion={form.direccion}
                  region={form.region}
                  comuna={form.comuna}
                  emergencia={form.t_emergencia}
                  fecha={primarySlot?.fecha}
                  hora={primarySlot?.hora}
                  servicio_raw={`${parsed.categoria}: ${parsed.variante}`}
                  servicio_categoria={parsed.categoria}
                  servicio_variante={parsed.variante}
                  descripcion={`Reserva ${parsed.categoria}: ${parsed.variante}`}
                  profesionalId={form.profesionalId || null}
                  profesionalNombre={form.profesionalNombre || null}
                  montoCLP={montoAPagarActual}
                  pago_tipo={opcionPago}
                  planId={planEntrada?.planId || null}
                  desdePlan={!!planEntrada}
                  cantidadSesiones={totalSesionesEstimadas}
                  varianteId={parsed?.meta?.id || null}
                  precioTotalPlan={!planEntrada && totalSesionesEstimadas > 1 ? precioFinal : null}
                  primeraSesionPlan={!!esPrimeraSesionReal}
                  modalidad={modalidadFinal}

                  /** 🔵 ESTE CAMPO ERA EL QUE FALTABA **/
                  planEntrada={planEntrada}

                  className="w-full border border-gray-300 rounded-xl p-4 text-left hover:bg-blue-50/40 transition"
                />
                )}

                {/* TRANSFERENCIA */}
                {configPago?.mostrar_transferencia && (
                <button
                  type="button"
                  onClick={() => {
                    if (!configPago?.mostrar_transferencia) {
                      alert("La transferencia no está disponible en este momento.");
                      return;
                    }
                    setPasoPago(3);
                  }}
                  className="w-full border border-gray-300 rounded-xl p-4 text-left hover:bg-blue-50/40 transition"
                >
                  <div className="flex items-center justify-between">
                    <div>
                      <div className="font-semibold text-[#0E1A36]">
                        Transferencia bancaria
                      </div>
                      <div className="text-sm text-gray-600">
                        Debes subir el comprobante. La reserva queda pendiente hasta que revisemos la transferencia (máximo en 24 horas).
                      </div>
                    </div>
                  </div>
                </button>
                )}
              </div>

              <div className="mt-5 flex justify-between">
                <button
                  className="px-4 py-2 text-sm text-gray-600 hover:text-gray-800"
                  onClick={() => setPasoPago(1)}
                >
                  Volver
                </button>
                <button
                  className="px-4 py-2 text-sm text-gray-600 hover:text-gray-800"
                  onClick={() => setModalAbierto(false)}
                >
                  Cerrar
                </button>
              </div>
            </div>
          )}

          {/* ================================
              PASO 3 - Transferencia
             ================================ */}
          {pasoPago === 3 && configPago?.mostrar_transferencia && (
            <div className="p-6">
              <div className="flex items-center justify-between">
                <div>
                  <h4 className="text-xl font-semibold text-[#0E1A36] mb-1">
                    Datos para transferencia
                  </h4>
                  <p className="text-sm text-[#4B5563]">
                    Monto:{" "}
                    <span className="font-semibold text-[#0E1A36]">
                      ${montoAPagarActual.toLocaleString("es-CL")}
                    </span>
                  </p>
                </div>

                <button
                  onClick={copiarDatosTransferenciaLocal}
                  className="inline-flex items-center gap-2 rounded-lg border border-gray-300 hover:bg-gray-50 px-3 py-2 text-sm hover:bg-blue-50/40"
                >
                  Copiar datos
                </button>
              </div>

              <div className="mt-3 rounded-xl border border-gray-300 bg-blue-50/40 p-4 text-sm space-y-1">
                <p><strong>Nombre:</strong> {datosTransferencia.nombre || "—"}</p>
                <p><strong>RUT:</strong> {datosTransferencia.rut || "—"}</p>
                <p><strong>Banco/App:</strong> {datosTransferencia.banco || "—"}</p>
                <p>
                  <strong>Cuenta:</strong>{" "}
                  {(datosTransferencia.tipo_cuenta || datosTransferencia.cuenta)
                    ? `${datosTransferencia.tipo_cuenta ? datosTransferencia.tipo_cuenta + " — " : ""}${datosTransferencia.cuenta || ""}`
                    : "—"}
                </p>
                <p><strong>Email:</strong> {datosTransferencia.email || "—"}</p>

                {!!datosTransferencia.mensaje && (
                  <p className="pt-2 text-gray-600">
                    {datosTransferencia.mensaje}
                  </p>
                )}
              </div>

              <div className="mt-5 space-y-3">
                <label className="block text-sm font-medium text-[#0E1A36]">
                  Subir comprobante
                </label>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => onPickComprobante(e.target.files?.[0] || null)}
                    className="w-full border border-gray-300 p-2 rounded-xl bg-white/90"
                  />

                  {formTransferencia.comprobanteFile && (
                    <p className="text-xs text-gray-600">
                      Archivo seleccionado:{" "}
                      <strong>{formTransferencia.comprobanteFile.name}</strong>
                    </p>
                  )}

                  {ocrLoading && (
                    <p className="text-xs text-gray-600">Analizando comprobante…</p>
                  )}

                  {!!ocrError && (
                    <p className="text-xs text-amber-700">{ocrError}</p>
                  )}

                  {ocrInfo && (
                    <div className="rounded-xl border border-gray-200 bg-gray-50 p-3 text-xs text-gray-700">
                      <div className="flex items-center justify-between">
                        <span className="font-semibold text-[#0E1A36]">Detección</span>
                      </div>

                      <div className="mt-2">
                        {esComprobanteProbable ? (
                          <span className="text-emerald-700 font-semibold">
                            Comprobante detectado
                          </span>
                        ) : esComprobanteDudoso ? (
                          <span className="text-amber-700 font-semibold">
                            Detectamos indicios que la captura subida es un comprobante
                          </span>
                        ) : (
                          <span className="text-rose-700 font-semibold">
                            No detectamos características que nos inidique un comprobante
                          </span>
                        )}
                      </div>
                    </div>
                  )}

                  {/* Declaración: aparece si OCR falló o salió "unlikely" */}
                  {(!!ocrError || esComprobanteImprobable) && (
                    <label className="flex items-start gap-2 text-xs text-gray-700">
                      <input
                        type="checkbox"
                        className="mt-0.5"
                        checked={declaracionOk}
                        onChange={(e) => setDeclaracionOk(e.target.checked)}
                      />
                      <span>
                        Declaro que la imagen corresponde a un comprobante de transferencia 
                        asociado a esta reserva. Además entiendo que, si el comprobante no corresponde 
                        o es fraudulento, la reserva podrá ser cancelada, conforme a los términos
                        y condiciones.
                      </span>
                    </label>
                  )}

                  <button
                    onClick={onEnviarComprobante}
                    disabled={enviando || bloquearEnvio}
                    className="px-5 py-2 rounded-xl font-semibold bg-emerald-500 text-white hover:brightness-110 disabled:opacity-70"
                  >
                    {enviando ? "Subiendo..." : ocrLoading ? "Analizando..." : "Enviar comprobante"}
                  </button>
              </div>

              <div className="mt-5 flex justify-between">
                <button
                  className="px-4 py-2 text-sm text-gray-600 hover:text-gray-800"
                  onClick={() => setPasoPago(2)}
                >
                  Volver
                </button>
                <button
                  className="px-4 py-2 text-sm text-gray-600 hover:text-gray-800"
                  onClick={() => setModalAbierto(false)}
                >
                  Cerrar
                </button>
              </div>
            </div>
          )}

        </div>
      </div>
    </div>
  );
}
